import useMediaQueries from 'app/hooks/useMediaQueries';
import { IUser } from 'app/services/user';
import Tooltip from 'Components/Tooltips';
import UserAvatar from 'Components/UserAvatar';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'utils/AuthProvider';

const CircleAvatar = ({
  children,
  containerSize,
  avatarSize,
}: {
  children: React.ReactNode;
  containerSize: string;
  avatarSize: string;
}) => {
  return (
    <div className={`${containerSize} cursor-pointer`}>
      <div
        className={`${avatarSize} text-dark-gray uppercase shadow rounded-full flex justify-center items-center  md-max:text-xs bg-gray-150 border border-white text-sm`}
      >
        {children}
      </div>
    </div>
  );
};
interface UserAvatarListProps {
  users: IUser[];
  size?: 'sm' | 'lg';
  dekstopLimit?: number;
  normalize?: boolean;
  mobileLimit?: number;
}
export default function UserAvatarList({
  users,
  size = 'lg',
  normalize = false,
  dekstopLimit = 5,
  mobileLimit = 2,
}: UserAvatarListProps) {
  const { md_down: isMobile } = useMediaQueries();
  const avatarLimit = isMobile ? mobileLimit : dekstopLimit;
  const navigate = useNavigate();
  const avatarSize =
    size === 'sm'
      ? 'w-7 h-7 text-xs'
      : 'w-10 h-10 md-max:h-7 md-max:w-7 text-sm md-max:text-xs';

  const containerSize =
    size === 'sm'
      ? 'w-6 h-7 text-xs'
      : 'w-8 h-10 md-max:h-7 md-max:w-6 text-sm md-max:text-xs';

  return (
    <div
      className={`flex ${
        normalize ? (size === 'sm' ? 'mr-1' : 'mr-2 md-max:mr-1') : ''
      }`}
    >
      {users &&
        users.length > 0 &&
        Array.from({
          length:
            avatarLimit > users.length
              ? users.length
              : avatarLimit === users.length
              ? avatarLimit
              : avatarLimit - 1,
        }).map((_, i) => {
          return (
            <Tooltip
              key={users[i].id}
              message={`${users[i].given_name} ${users[i].family_name}`}
            >
              <div className={`${containerSize} cursor-pointer `}>
                <UserAvatar user={users[i]} size={avatarSize} />
              </div>
            </Tooltip>
          );
        })}
      {users && users.length - avatarLimit > 0 && (
        <CircleAvatar
          containerSize={containerSize}
          avatarSize={avatarSize}
        >{`+${users.length - avatarLimit + 1}`}</CircleAvatar>
      )}
    </div>
  );
}
